import axios from 'axios';

const API_URL = 'https://wifi-api.redia-maroc.com';

const api = axios.create({ baseURL: API_URL });

api.interceptors.request.use(config => {
  const token = localStorage.getItem('redia_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  res => res,
  err => {
    if (err.response?.status === 401) {
      localStorage.removeItem('redia_token');
      localStorage.removeItem('redia_user');
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

export const authAPI = {
  login: (email, password) => {
    const form = new URLSearchParams();
    form.append('username', email);
    form.append('password', password);
    return api.post('/v1/auth/login', form,
      { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }});
  },
  me: () => api.get('/v1/auth/me'),
};

export const sitesAPI = {
  list:             ()            => api.get('/v1/sites'),
  get:              (id)          => api.get(`/v1/sites/${id}`),
  create:           (data)        => api.post('/v1/sites', data),
  updateConfig:     (id, data)    => api.put(`/v1/sites/${id}/config`, data),
  getCorrection:    (id)          => api.get(`/v1/sites/${id}/correction`),
  updateCorrection: (id, data)    => api.put(`/v1/sites/${id}/correction`, data),
};

export const sensorsAPI = {
  create: (data) => api.post('/v1/sensors', data),
  delete: (id)   => api.delete(`/v1/sensors/${id}`),
  status: ()     => api.get('/v1/tracking/status'),
  logs:   (id, limit) => api.get('/v1/sensors/' + id + '/logs?limit=' + (limit || 100)),
  reboot:     (id)       => api.post('/v1/sensors/' + id + '/reboot'),
  ota:        (id, fd)   => api.post('/v1/sensors/' + id + '/ota', fd, { headers: { 'Content-Type': 'multipart/form-data' } }),
  unassigned: ()         => api.get('/v1/sensors/unassigned'),
  assign:     (id, data) => api.post('/v1/sensors/' + id + '/assign', data),
};

// Campagne de calibration multi-capteurs (1.8.0+). A ne pas confondre avec
// calibrationAPI, qui sert l ANCIENNE methode : un capteur a la fois, des
// distances mesurees au metre, et l ajustement de n a partir d un txpower
// suppose. Cette methode-la est abandonnee.
export const campagneAPI = {
  start:      (data)  => api.post('/v1/campagne/start', data),
  close:      (sid)   => api.post(`/v1/campagne/${sid}/close`),
  openPoint:  (sid, data) => api.post(`/v1/campagne/${sid}/point`, data),
  pointStatus:(sid, pid)  => api.get(`/v1/campagne/${sid}/point/${pid}/status`),
  closePoint: (sid, pid)  => api.post(`/v1/campagne/${sid}/point/${pid}/close`),
  emitters:   ()      => api.get('/v1/calibration/emitters'),
};

export const walkthroughAPI = {
  start:           (data)   => api.post('/v1/walkthrough/start', data),
  checkpoint:      (data)   => api.post('/v1/walkthrough/checkpoint', data),
  confirmPosition: (data)   => api.post('/v1/walkthrough/confirm-position', data),
  getSession:      (id)     => api.get(`/v1/walkthrough/session/${id}`),
  finalize:        (id)     => api.post(`/v1/walkthrough/finalize/${id}`),
  getSensors:      (siteId) => api.get(`/v1/walkthrough/sensors/${siteId}`),
};

export const enrollmentAPI = {
  start:   (data) => api.post('/v1/enrollment/start', data),
  confirm: (data) => api.post('/v1/enrollment/confirm', data),
  stop:    (data) => api.post('/v1/enrollment/stop', data),
};

export const zonesAPI = {
  list:   (siteId)       => api.get('/v1/heatmap/' + siteId + '/zones'),
  create: (siteId, data) => api.post('/v1/heatmap/' + siteId + '/zones', data),
  update: (siteId, zoneId, data) => api.put('/v1/heatmap/' + siteId + '/zones/' + zoneId, data),
  delete: (siteId, zoneId) => api.delete('/v1/heatmap/' + siteId + '/zones/' + zoneId),

  // Carte de frequentation par ZONAGE GRADUE. Le serveur rend le SVG tout
  // pret : le front n a rien a dessiner, il l affiche. `jours_sains` ecarte
  // les journees ou un capteur etait hors service — sans quoi la carte
  // refleterait la panne et non la frequentation.
  zonage: (siteId, from, to) =>
    api.get('/v1/heatmap/' + siteId + '/zonage', {
      params: { from_date: from, to_date: to, format: 'svg', jours_sains: true },
      responseType: 'text',
    }),
};

export const dashboardAPI = {
  realtime: (siteId, date, dist) => { const p = new URLSearchParams(); if (date) p.set("date", date); if (dist) p.set("max_distance", dist); const qs = p.toString(); return api.get(`/v1/dashboard/${siteId}/realtime${qs ? "?" + qs : ""}`); },
  history:  (siteId, days) => api.get(`/v1/dashboard/${siteId}/history?days=${days}`),
};

export default api;

export const floorplanAPI = {
  upload:         (siteId, fd)       => api.post('/v1/sites/' + siteId + '/floorplan', fd),
  getUrl:         (siteId)           => 'https://wifi-api.redia-maroc.com/v1/sites/' + siteId + '/floorplan',
  remove:         (siteId)           => api.delete('/v1/sites/' + siteId + '/floorplan'),
  updatePosition: (sensorId, data)   => api.put('/v1/sensors/' + sensorId + '/position', data),
  getSensors:     (siteId)           => api.get('/v1/sensors?site_id=' + siteId),
};
